"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const classnames_1 = __importDefault(require("classnames"));
const _1 = require("../.");
/**
 * A multiple select dropdown.
 */
const MultiSelect = ({ name, value, placeholder, mandatory, setValue, options, }) => {
    const [isOpen, setIsOpen] = react_1.default.useState(false);
    const selectClasses = (0, _1.useSelectStyles)();
    const multiSelectClasses = (0, exports.useStyles)();
    const classes = Object.assign(Object.assign({}, selectClasses), multiSelectClasses);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(classes.select, classes.multiSelect, 'rfc-input rfc-select'), onClick: () => !isOpen && setIsOpen(true) },
        value && value.length && options && options.length
            ? react_1.default.createElement("div", { className: classes.values }, value.map((option, index) => {
                const currentOption = options.find((item) => (typeof item === 'object' && item.value === option) || item === option) || 'n/d';
                const { optionLabel } = (0, _1.parseOption)(currentOption);
                return react_1.default.createElement("span", { key: index, className: classes.value }, optionLabel);
            }))
            : placeholder || (mandatory ? 'Select' : 'All'),
        isOpen &&
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: classes.overlay, onClick: () => setIsOpen(false) }),
                react_1.default.createElement("div", { className: classes.options }, options.map((option, index) => {
                    const { optionLabel, optionValue } = (0, _1.parseOption)(option);
                    const checked = (value && value.includes(optionValue));
                    return react_1.default.createElement("div", { key: index, className: (0, classnames_1.default)(classes.option, { [classes.isChecked]: checked }), onClick: () => {
                            const finalValue = (0, _1.checkboxHandler)(!checked, optionValue, value);
                            setValue(name, finalValue, mandatory, { touched: true });
                        } },
                        optionLabel,
                        checked &&
                            react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("span", { className: classes.check }, "\u2713"),
                                react_1.default.createElement("span", { className: classes.close }, "\u2717")));
                })))));
};
exports.useStyles = (0, react_jss_1.createUseStyles)((theme) => ({
    multiSelect: {
        position: 'relative',
        height: 'auto !important',
    },
    values: {
        margin: -3,
    },
    value: {
        padding: '0 5px',
        backgroundColor: theme.colors.fill,
        borderRadius: 3,
        whiteSpace: 'nowrap',
        display: 'inline-block',
        margin: 3,
    },
    options: {
        position: 'absolute',
        top: '100%',
        left: -1,
        right: -2,
        height: theme.sizes.inputHeight * 5,
        border: `1px solid ${theme.colors.inputBorder}`,
        backgroundColor: 'white',
        zIndex: 101,
        overflowY: 'scroll',
    },
    option: {
        padding: '3px 5px',
        marginBottom: 1,
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between',
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.04)',
        },
    },
    isChecked: {
        backgroundColor: 'rgba(0,0,0,0.12)',
        '&:hover ': {
            backgroundColor: 'rgba(0,0,0,0.08)',
            '& $check': {
                display: 'none',
            },
            '& $close': {
                display: 'inline',
            },
        },
    },
    check: {
        color: 'rgba(0,0,0,0.12)',
    },
    close: {
        display: 'none',
        color: 'rgba(0,0,0,0.2)',
    },
    overlay: Object.assign({}, (0, _1.overlay)()),
}));
exports.default = (0, _1.withFormControl)(MultiSelect);
